import DialChart from "../molecules/DialChart";
import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailAcne({data, img}) {
    return (
        <MeasurementResult type="포르피린" description="모낭에는 다양한 미생물이 있으며, 특히 프로피오니박테리움 아크네가 대량으로 번식합니다." score={data.score}>

            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        {
                            img.image_cross_polar_front &&
                            <img src={img.image_cross_polar_front} />
                        }
                        {
                            img.image_mark_other_spots_front &&
                            <img src={img.image_mark_other_spots_front} />
                        }

                        <div className="caption">화이트 라이트</div>
                    </div>
                    <div className="img-cont">
                        {
                            img.image_uv_front &&
                            <img src={img.image_uv_front} />
                        }
                        {
                            img.image_mark_porphyrin_front &&
                            <img src={img.image_mark_porphyrin_front} />
                        }
                        <div className="caption">UV</div>
                    </div>
                </div>

                <DegreeSection type="포르피린" 
                text={data.degreeText} 
                level={data.level}
                badge={data.analysisBadge}
                items={[
                    {
                        value: "없음",
                        level: 0
                    },
                    {
                        value: "I급",
                        level: 1
                    },
                    {
                        value: "II급",
                        level: 2
                    },
                    {
                        value: "III급",
                        level: 3
                    },
                    {
                        value: "IV급",
                        level: 4
                    },
                ]} 
                line={3}
                />

                {
                    data.troubleList && 
                    <section className="flex-content-center">
                        <div className="h4">전체 얼굴내 점유비율</div>

                        <div className="h-100 d-flex align-items-center">
                            <DialChart value={data.percentage} />
                        </div>
                    </section>
                }
            </div>

            <div className="row-wrap">
                {
                    !data.troubleList && 
                    <section className={data.troubleList ? "flex-content-center" : "direction-row flex-content-center"}>
                        <div className="h4">전체 얼굴내 점유비율</div>

                        <div className="h-100 d-flex align-items-center">
                            <DialChart value={data.percentage} />
                        </div>
                    </section>
                }
                <section className={data.troubleList ? "direction-row flex-content-center flex-grow-0" : "direction-row flex-content-center"}>
                    <div className="h4">
                        포르피린
                        <br />
                        가능 비율
                    </div>
                    <DialChart value={data.possibility} />
                </section>

                {
                data.count &&
                <section>
                    <div className="h4">포르피린 타입</div>

                    <ul className="score-list">
                        <li>
                            <div className="caption">좁쌀</div>
                            <div className="value">
                                {data.count.comedones} <span>개</span>
                            </div>
                        </li>
                        <li>
                            <div className="caption">구진성</div>
                            <div className="value">
                                {data.count.papules} <span>개</span>
                            </div>
                        </li>
                        <li>
                            <div className="caption">결절성</div>
                            <div className="value">
                                {data.count.nodules} <span>개</span>
                            </div>
                        </li>
                        <li>
                            <div className="caption">흉터</div>
                            <div className="value">
                                {data.count.acne_marks} <span>개</span>
                            </div>
                        </li>
                    </ul>
                </section>
                }
            </div>

            <div className="row-wrap grow">
                
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    hideTitle={true} 
                    text={data.aiResult} 
                    line={4}
                />
            </div>
        </MeasurementResult>
    )
}